import { runAction } from "../client";
import { EntityType } from "../../models/EntityType";
import { ServiceAccount } from "../../models/ServiceAccount";
import { Vehicle } from "../../models/Vehicle";
import { Division } from "../../models/Division";
import { Sensor } from "../../models/Sensor";

export interface UpsertRequest
{
    type: EntityType,
    entity: any
}

export interface CommitEntityResult
{
    Success: boolean;
	ErrorMessage: string;
    ServiceAccount?: ServiceAccount;
    Vehicle?: Vehicle;
    Division?: Division;
    Sensor?: Sensor;
}

export interface CommitFn
{
    (request: UpsertRequest): Promise<CommitEntityResult>;
}

export const commitEntity: CommitFn = (request: UpsertRequest): Promise<CommitEntityResult> => {

    const { type, entity } = request;
    const key = EntityType[type];
    return runAction<CommitEntityResult>('/action/CommitObject', {[key]: entity});
};


// WEBPACK FOOTER //
// ./src/rest/Commit/index.ts